import { Query } from 'cogent-js';
import BaseApiService from './base';

export default class TrayDesignRequestApiService extends BaseApiService {
  constructor() {
    super();
    this.query = new Query();
  }

  get(id) {
    return this.request({
      method: 'get',
      url: `/tray-design-requests/${id}`
    });
  }

  update(id, data) {
    return this.request({
      method: 'put',
      url: `/tray-design-requests/${id}`,
      data
    });
  }
}
